import { combineReducers } from "redux";
import processReducer from "./processReducer";
import selectedReducer from "./selectedReducer";
import adminReducer from "./adminReducer";
import modalReducer from "./modalReducer";
import errorReducer from "./errorReducer";

export default combineReducers({
  process: processReducer,
  selected: selectedReducer,
  admin: adminReducer,
  modal: modalReducer,
  error: errorReducer
});
